import { render } from "./InputRadio.vue?vue&type=template&id=e364602a&scoped=true&ts=true"
import script from "./InputRadio.vue?vue&type=script&lang=ts"
export * from "./InputRadio.vue?vue&type=script&lang=ts"

import "./InputRadio.vue?vue&type=style&index=0&id=e364602a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e364602a"]])

export default __exports__